import { agent } from '../utils/agent'
const API_URL = process.env.REACT_APP_API_URL

const getAds = async (offset = 0, itemsPerPage = 0, activePage = 0, params = []) => {
  const response = await agent.get(
    `${API_URL}ads-manager/listing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}
const gameAdsListing = async (offset = 0, itemsPerPage = 0, activePage = 0, params = []) => {
  const response = await agent.get(
    `${API_URL}ads-manager/gameAdsListing?offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}
const getAdsByFromGameId = async (params) => {
  const response = await agent.get(`${API_URL}ads-manager/getAdsByFromGameId`, { params })
  return response.data
}
const saveAd = async (data) => {
  const response = await agent.post(API_URL + 'ads-manager/save-ads', data)
  return response.data
}
const editAds = async (data) => {
  const response = await agent.post(API_URL + 'ads-manager/edit-ads', data)
  return response.data
}
const getAdsDetail = async (id) => {
  const response = await agent.get(`${API_URL}ads-manager/ads-details/${id}`)
  return response.data
}
const deleteAds = async (data) => {
  const response = await agent.post(API_URL + 'ads-manager/delete-ads', data)
  return response.data
}
const updateFeatured = async (id, status) => {
  const response = await agent.get(`${API_URL}ads-manager/update-featured/${id}/${status}`)
  return response.data
}
const updateStatus = async (id, status) => {
  const response = await agent.get(`${API_URL}ads-manager/update-status/${id}/${status}`)
  return response.data
}

const imageUpload = async (formData) => {
  const response = await agent.post(`${API_URL}ads-manager/imageUpload`, formData)
  return response.data
}

const updateDisplayOrder = async (formData) => {
  const response = await agent.post(`${API_URL}ads-manager/updateDisplayOrder`, formData)
  return response.data
}
const AdsManagerService = {
  getAds,
  gameAdsListing,
  saveAd,
  deleteAds,
  getAdsDetail,
  editAds,
  updateFeatured,
  updateStatus,
  imageUpload,
  getAdsByFromGameId,
  updateDisplayOrder,
}

export default AdsManagerService
